import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import styled, { css } from 'styled-components';
import { Badge } from '../../../../../../indicators/Badge';
import { Box } from '../../../../../../layout/Box';
import { Icon, IconCaretDown } from '../../../../../../imagesAndIcons/Icon';
import { ItemMenu } from '../ItemMenu';
import { Text } from '../../../../../../typography/Text';
import { TextButton } from '../../../../../../actions/TextButton';
import { getTextButtonVariantFromItemVariant, getTextColorFromItemVariant } from '../../utilites';
import { ICON_DEFAULTS } from '../../constants';
import { styledFactory } from '../../../../../../../utilities/styled-components';

var Item =
/** @class */
function (_super) {
  __extends(Item, _super);

  function Item() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.renderItem = function (itemContent) {
      var unread = _this.props.unread;

      if (unread) {
        var xOffset = unread.toString().length === 2 ? 14 : 20;
        return React.createElement(Box, __assign({}, _this.boundingBoxProps), React.createElement(Badge, {
          backgroundColor: Badge.BackgroundColor.System,
          target: itemContent,
          xOffset: xOffset,
          yOffset: 65
        }, _this.props.unread));
      }

      return React.createElement(Box, __assign({}, _this.boundingBoxProps), itemContent);
    };

    _this.renderLink = function () {
      var _a = _this.props,
          customNode = _a.customNode,
          disabled = _a.disabled,
          url = _a.url,
          label = _a.label,
          onClick = _a.onClick,
          variant = _a.variant;
      var href = disabled ? undefined : url;
      var iconComponent = _this.iconComponent;

      if (iconComponent) {
        return React.createElement(ItemLiAnchor, {
          disabled: disabled,
          hasHover: true,
          href: href,
          onClick: onClick
        }, iconComponent);
      } else if (customNode) {
        return React.createElement(ItemLiAnchor, {
          disabled: disabled,
          href: href,
          onClick: onClick
        }, customNode);
      }

      return React.createElement(TextButton, {
        disabled: disabled,
        href: url,
        onClick: onClick,
        size: TextButton.Size.Sm,
        underline: false,
        variant: getTextButtonVariantFromItemVariant(variant),
        weight: TextButton.Weight.Medium
      }, label);
    };

    _this.renderMenuHandle = function () {
      var _a = _this.props,
          customNode = _a.customNode,
          disabled = _a.disabled,
          label = _a.label,
          variant = _a.variant;
      var iconComponent = _this.iconComponent;

      if (iconComponent) {
        return React.createElement(React.Fragment, null, iconComponent);
      } else if (customNode) {
        return React.createElement(React.Fragment, null, customNode);
      }

      return React.createElement(Box, {
        pv: 0.5
      }, React.createElement(Text, {
        color: disabled ? Text.Color.Gray2 : getTextColorFromItemVariant(variant),
        size: Text.Size.Sm,
        weight: Text.Weight.Medium
      }, label), React.createElement(CaretWrapper, null, React.createElement(IconCaretDown, {
        size: Icon.Size.Xxs
      })));
    };

    return _this;
  }

  Object.defineProperty(Item.prototype, "hasDropdown", {
    get: function get() {
      return this.props.items && this.props.items.length > 0;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Item.prototype, "iconComponent", {
    get: function get() {
      return this.props.icon ? React.createElement(this.props.icon, __assign(__assign({}, ICON_DEFAULTS), {
        title: this.props.label
      })) : null;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(Item.prototype, "boundingBoxProps", {
    get: function get() {
      var _a = this.props,
          customNode = _a.customNode,
          icon = _a.icon,
          isEdgeItem = _a.isEdgeItem,
          rightAlign = _a.rightAlign;
      var paddingUnits = icon || customNode ? 2.5 : 3;
      var largerPadding = 0.75 * paddingUnits;
      var smallerPadding = 0.25 * paddingUnits;
      var pr = rightAlign ? smallerPadding : largerPadding;
      var pl = rightAlign ? largerPadding : smallerPadding;

      if (isEdgeItem) {
        if (rightAlign) {
          pr = 0;
        } else {
          pl = 0;
        }
      }

      return {
        pl: {
          xs: pl * 0.9,
          lg: pl
        },
        pr: {
          xs: pr * 0.9,
          lg: pr
        }
      };
    },
    enumerable: true,
    configurable: true
  });

  Item.prototype.render = function () {
    if (this.hasDropdown) {
      return React.createElement(ItemMenu, __assign({}, this.props), this.renderItem(this.renderMenuHandle()));
    }

    return this.renderItem(this.renderLink());
  };

  return Item;
}(React.Component);

export { Item };
var ItemLiAnchor = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    cursor: ", ";\n    display: inline-flex; // Needed for bounding box\n    padding: ", ";\n    ", ";\n"], ["\n    position: relative;\n    cursor: ", ";\n    display: inline-flex; // Needed for bounding box\n    padding: ", ";\n    ", ";\n"])), function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, function (props) {
  return props.theme.units.getValues([2, 0]);
}, function (props) {
  return props.hasHover && !props.disabled && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            &:hover {\n                opacity: 0.75;\n            }\n        "], ["\n            &:hover {\n                opacity: 0.75;\n            }\n        "])));
});
var CaretWrapper = styledFactory(styled.div)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: inline-block;\n    margin-left: ", ";\n    transform: translateY(", ");\n"], ["\n    display: inline-block;\n    margin-left: ", ";\n    transform: translateY(", ");\n"])), function (props) {
  return props.theme.units.getValue(1);
}, function (props) {
  return props.theme.units.getValue(0.2);
});
var templateObject_1, templateObject_2, templateObject_3;